

import $ from 'jquery';

(function(){
	'use strict';

	function setCookie(cookieKey, cookieValue, expireMinutes) {
		let cookie = cookieKey + "=" + cookieValue;
		const d = new Date();
		d.setTime(d.getTime() + (expireMinutes*60*1000));
		let expires = "expires=" + d.toUTCString();

		// set cookie with expiry
		document.cookie = cookie + ";" + expires + ";path=/";

		// remove overlay-repeated div
		document.getElementsByClassName('overlay-repeated')[0].style.display = "none";
	}

	function checkCookieHasValue(cookie){
		// check if cookie set
		if (document.cookie.split(';').some((item) => item.includes(cookie))) {
			// show overlay-repeated text
			document.getElementsByClassName('overlay-repeated')[0].style.display = "block";
		} else {
			// set cookie values (expiry in minutes)
			//  ***** setting cookie should be done when submitting an actual form *****
			setCookie("crimeClicked", true, 1);
			
		}
	}

	$('.afp-forms__card').on("click", function (event) {
		event.preventDefault();
		var linkDestination = event.currentTarget.href;
		
		// show overlay
		$(".afp-forms__overlay").css("display", "block");
		
		// set "Yes" link destination to original cards href
		$(".overlay-button--yes").parent().attr("href", linkDestination);
		
		// check if cookie already set
		checkCookieHasValue('crimeClicked=true');

	})

	$('.overlay-close').on("click", function () {
		$(".afp-forms__overlay").css("display", "none");
	})

	$(window).on("beforeunload", function (event) {
		// event.preventDefault();
		document.cookie = "crimeClicked=; expires=Thu, 01 Jan 1970 00:00:00 GMT;";
		// Suppress the browser message popup.
		event.returnValue = "Exit";
	})
}());
